import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as ResumoHttp from '../../../../services/api/https/picking/resumo-separcao.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET: 'Adquirindo ',
}

const INITIAL_STATE = {
  entregas: {},
  selecionarTodos: false,
  tabActiveIndex: 0,
  tabFaltasIndex: 0,
  leftover_products: {
    products: [],
    missing_reasons: [],
  },
  missing_products: {
    byIdentifier: {
      missing_reasons: [],
      deliveries: [],
    },
    byRoute: [
      {
        placa_prevista_carregamento: 0,
        clientes: [],
      },
    ],
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useResumoSeparacaoManual() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getResumoSeparacaoManualInfo(selectedPicking) {
        ResumoHttp.getResumoSeparacaoManualInfo(selectedPicking.id)
          .then(info => {
            setState(prevState => ({
              ...prevState,
              missing_products: info.missing_products,
              leftover_products: info.leftover_products,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET }))
      },
    }
  }, [])

  return { state, localDispatch }
}
